var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FeedbackWrapper",
    {
      attrs: {
        loading: _vm.isLoading,
        "no-data": _vm.isFeedback,
        "with-border": "",
        "icon-name": _vm.resolvedIcon,
        "icon-color": _vm.resolvedColor,
        message: _vm.resolvedMessage,
        "min-height": _vm.minHeight
      },
      scopedSlots: _vm._u(
        [
          _vm.$slots.button
            ? {
                key: "button",
                fn: function() {
                  return [_vm._t("button")]
                },
                proxy: true
              }
            : null
        ],
        null,
        true
      )
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }